export enum ConditionType {
    Contains = 'contains',
    NotContains = 'notContains',
    StartsWith = 'startsWith',
    EndsWith = 'endsWith',
    Equals = 'equals',
    NotEqual = 'notEqual',

    GreaterThan = 'greaterThan',
    GreaterThanOrEqual = 'greaterThanOrEqual',
    LessThan = 'lessThan',
    LessThanOrEqual = 'lessThanOrEqual',
    IsBlank = 'blank',
    IsNotBlank = 'notBlank',

    InRange = 'inRange'
}

export enum ControlType {
    Input = 'input',
    Numeric = 'numeric',
    // TextArea = 'textarea',
    Select = 'select',
    // Radio = 'radio',
    // Checkbox = 'checkbox',
    DateTime = 'datetime',
    // Switch = 'switch',
    AutoComplete = 'autocomplete'
}

export enum ControlConditionType {
    AND = 'AND',
    OR = 'OR'
}